import React, { useContext, useEffect, useState } from 'react';
import Header from './Components/Header/index';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import LinearProgress from '@mui/material/LinearProgress';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { GrFormAdd } from 'react-icons/gr';
import { BiMinus } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context/authContext';
import {
  getAllPrograms,
  getApplicationsByApplicantId,
} from '../../Utils/apiServices';
import KenLoader from '../../Components/KenLoader';
import moment from 'moment';
import { FormContext } from '../../Context/formContext';
import KenDialog from '../../Components/KenDialog/index';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { QuestionContent, TABLET_BREAKPOINT } from '../../Constants/constant';
import { makeStyles } from '@mui/styles';
import Carousel from 'nuka-carousel';
import BannerImage from '../../Assets/horizontalBanner.png';
import CardImage from '../../Assets/card.png';

// const root = document.querySelector('root');
// const secondary = getComputedStyle(root).getPropertyValue('--secondaryTheme');

const useStyles = makeStyles((theme) => ({
  typoToggleOpenHeading: {
    color: '#07588F',
    fontSize: '14px',
    fontWeight: '600',
  },
  carousel: {
    borderRadius: '16px',
    'box-shadow':
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    height: 500,
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      borderRadius: 0,
      boxShadow: 'unset',
    },
  },
  container: {
    // padding: theme.spacing(3),
    background: '#F8F8FB',
    borderRadius: '16px',
    'box-shadow':
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      borderRadius: 0,
      minHeight: '210px',
      boxShadow: 'unset',
    },
    img: {
      height: '200px',
      width: '100%',
    },
  },
}));

const CardContent = [
  {
    EventImg: require('../../Assets/Images/Homepage/EventImg1.jpg'),
    EventName: 'Turbostart Launchpad',
    EventDescription:
      'Elevate your business and take the next leap towards success.',
    EventLastDate: '30th July, 2023',
  },
  {
    EventImg: require('../../Assets/Images/Homepage/EventImg2.jpg'),
    EventName: '2023-Startup Mela',
    EventDescription:
      'Secure your spot to pitch, network, and secure funding for your groundbreaking venture.',
    EventLastDate: '30th July, 2023',
  },
  {
    EventImg: require('../../Assets/Images/Homepage/EventImg1.jpg'),
    EventName: 'Turbostart Launchpad',
    EventDescription:
      'Elevate your business and take the next leap towards success.',
    EventLastDate: '30th July, 2023',
  },
];

const Dashboard = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [toggleValue, setToggleValue] = useState(0);
  const [Open, setOpen] = useState(true);
  const [loader, setLoading] = useState();
  const [dialog, setDialog] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [applications, setApplications] = useState([]);
  const [sameApplicationData, setSameApplicationData] = useState();
  const { formState, formDispatch } = useContext(FormContext);
  const {
    state: { user },
  } = useContext(AuthContext);

  const theme = useTheme();

  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  const goToSameApplication = () => {
    formDispatch({
      type: 'new',
      payload: {
        programDetails: sameApplicationData,
        applicationId: sameApplicationData.Id,
        formId: sameApplicationData.Startup_Application_Form__c,
      },
    });
    console.log(
      `?applicationId=${sameApplicationData.Id}&formId=${sameApplicationData.Startup_Application_Form__c}`
    );
    navigate({
      pathname: '/application',
      search: `?applicationId=${sameApplicationData.Id}&formId=${sameApplicationData.Startup_Application_Form__c}`,
    });
  };

  useEffect(() => {
    setLoading(true);
    getAllPrograms(user?.applicantId)
      .then((res) => {
        if (res?.data) {
          let data = [];
          res?.data?.forEach((el, index) => {
            const isBetween = moment(el?.endDate).diff(moment(), 'day');
            if (isBetween >= 0) {
              data?.push({
                ...el,
                ...CardContent[index],
                EventLastDate: el?.endDate,
                EventName: el?.formName,
                bannerImage: BannerImage,
                cardImage: CardImage,
              });
            }
          });
          setPrograms([...data]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    getApplicationsByApplicantId(user?.applicantId)
      .then((res) => {
        let data = [];
        if (res?.data?.length > 0) {
          //   setApplications([...res?.data]);
          res?.data?.forEach((el, index) => {
            console.log(
              Number(el?.Current_Step__c) /
                Number(el?.Startup_Application_Form__r?.Total_Steps__c)
            );
            const isBetween = moment(el?.endDate).diff(moment(), 'day');
            data.push({
              ...el,
              ...applications[index],
              CardHeading: el?.formName,
              ProgressRate:
                el?.hed__Application_Status__c === 'Application form Submitted'
                  ? 100
                  : (
                      Number(el?.Current_Step__c) /
                      (Number(
                        el?.Startup_Application_Form__r?.Total_Steps__c
                      ) || 0)
                    ).toFixed(2) * 100,
              disabled: isBetween > 0 ? false : true,
            });
          });
          setApplications([...data]);

          setLoading(false);
        } else {
          setApplications([...data]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  //   useEffect(() => {
  //     setProgress(55);
  //   }, []);

  const NotFound = (props) => {
    return (
      <div className="d-flex justify-content-center flex-column align-items-center w-100 my-5">
        <img src={props.img} alt="notFound" />
        {props.mainContent && (
          <h2 className="font-primary-16-bold mt-2">{props.mainContent}</h2>
        )}
        {props.subContent && (
          <h2 className="font-black-16-bold mt-2">{props.subContent}</h2>
        )}
      </div>
    );
  };

  const goToApplicationForm = (item) => {
    console.log(item);
    formDispatch({
      type: 'new',
      payload: {
        programDetails: item,
        applicationId: item.Id,
        formId: item.Startup_Application_Form__c,
      },
    });

    navigate({
      pathname: '/application',
      search: `?applicationId=${item.Id}&formId=${item.Startup_Application_Form__c}`,
    });
  };

  return (
    <div>
      {loader && <KenLoader />}
      <Header
        Heading={
          <h1 className="font-black-24-normal w-100 ">
            👋 Hello,{' '}
            <b className="font-black-24-superbold">{user?.applicantName}</b>
          </h1>
        }
        divider={true}
        user={user}
      />
      <div className="PageContainer">
        {!isMobileScreen && (
          <>
            <Carousel
              autoplay={programs?.length <= 1 ? false : true}
              wrapAround={true}
              renderCenterRightControls={({ nextSlide }) => ''}
              renderCenterLeftControls={({ previousSlide }) => ''}
              withoutControls={programs?.length <= 1 ? true : false}
              className={classes.carousel}
            >
              {programs?.map((el) => {
                return (
                  <img
                    src={el?.bannerImage ? el?.bannerImage : el?.cardImage}
                    // onClick={() => {
                    //   navigate('/events', {
                    //     state: {
                    //       ...el,
                    //     },
                    //   });
                    // }}
                    alt="EventImg"
                    className="w-100"
                    height={'330px'}
                    style={{ objectFit: 'cover' }}
                  ></img>
                );
              })}
            </Carousel>
            {/* </Grid>
            </Grid> */}
            {/* </div> */}
          </>
        )}
        {/* </div> */}
        <Grid container spacing={3} className="mt-1">
          <Grid item md={3} className="w-100">
            <div>
              <Grid container spacing={2}>
                <Grid item md={12} className="w-100">
                  <Box
                    component={'div'}
                    width={'100%'}
                    height={'100%'}
                    className="bg-white rounded-2 shadow-sm"
                    padding={'17px 20px 0px'}
                  >
                    <div className="d-flex align-items-center gap-2">
                      {applications.length === 0 ? (
                        ''
                      ) : (
                        <Avatar
                          sx={{
                            backgroundColor: '#07588F',
                            width: '25px',
                            height: '25px',
                          }}
                        >
                          <span className="font-white-14-normal">
                            {applications.length}
                          </span>
                        </Avatar>
                      )}
                      <h2 className="font-black-16-bold pt-2">
                        Pending Actions
                      </h2>
                    </div>
                    {applications.length === 0 ? (
                      <NotFound
                        img={require('../../Assets/Images/Homepage/application_notFound.png')}
                        subContent="No actions pending"
                      />
                    ) : (
                      <Box
                        component={'div'}
                        marginTop={'20px'}
                        marginBottom={'30px'}
                        className="scroller-section"
                      >
                        {applications?.map((item, index) => (
                          <Box
                            component={'div'}
                            padding={'14px 12px'}
                            key={index}
                            width={'100%'}
                            height={'152px'}
                            className="my-3"
                            // bgcolor={`${secondary}`}
                          >
                            <h2 className="font-black-14-bold">
                              {item?.Startup_Application_Form__r?.Name}
                            </h2>
                            <p className="font-grey-12-normal">
                              {
                                item?.Startup_Application_Form__r
                                  ?.Participate__r?.Title__c
                              }
                            </p>
                            <div className="d-flex w-100 gap-3">
                              <LinearProgress
                                sx={{ height: '7px', width: '100%' }}
                                className="rounded-2"
                                value={item.ProgressRate}
                                variant="determinate"
                              />
                              <Box
                                component={'div'}
                                marginTop={'-6px'}
                                className="font-grey-14-bold"
                              >
                                {item.ProgressRate}%
                              </Box>
                            </div>
                            <div className="d-flex justify-content-between mt-3 align-items-center">
                              <h3 className="font-grey-12-normal text-center pt-2">
                                <i>{item.EditedDate}</i>
                              </h3>
                              <button
                                className="primary-contained-button px-3 py-1 mx-2 rounded-2"
                                onClick={() => {
                                  goToApplicationForm(item);
                                }}
                              >
                                {item.hed__Application_Status__c
                                  ? item?.hed__Application_Status__c ===
                                    'Application form Incomplete'
                                    ? 'Complete Application'
                                    : 'View Application'
                                  : 'Apply'}
                              </button>
                            </div>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item md={9}>
            <div>
              <Grid container spacing={2}>
                <Grid item md={12}>
                  <Box
                    component={'div'}
                    width={'100%'}
                    height={'100%'}
                    className="bg-white rounded-2 shadow-sm"
                    padding={'30px 17px 0px'}
                  >
                    <h1 className="font-black-16-bold pb-3">Apply Now</h1>
                    {programs.length === 0 ? (
                      <NotFound
                        img={require('../../Assets/Images/Homepage/NotFound-Eventimg.png')}
                        mainContent="No upcoming programs"
                        subContent="Stay tuned for more"
                      />
                    ) : (
                      <Grid
                        container
                        // gap={2}
                        spacing={2}
                        // sx={{ overflowX: 'scroll', whiteSpace: 'nowrap' }}
                        className="card border-0 Events-container"
                        style={{
                          flexGrow: 1,
                          overflowX: 'auto', // Enable horizontal scrolling
                          maxWidth: '100%',
                          display: 'flex', // Make the container a flex container
                          flexWrap: 'nowrap',
                        }}
                      >
                        {programs.map((item, index) => (
                          <Grid
                            item
                            style={{
                              flex: '0 0 calc(33.33% - 16px)', // Each card takes 33.33% of the container's width
                              maxWidth: '33.33%',
                              margin: '8px',
                            }}
                            key={index}
                          >
                            <Box
                              component={'div'}
                              height={'fit-content'}
                              className="w-100 rounded-2"
                              marginBottom={'17px'}
                              padding={'15px'}
                              bgcolor={'#F7F7F8'}
                            >
                              <img
                                src={item?.cardImage}
                                alt={`${item.EventName}`}
                                className="rounded-3"
                                height={'150px'}
                                width={'100%'}
                              />
                              <div
                                // className="p-1 align-items-center"
                                sx={{
                                  float: 'center !important',
                                  texAlign: 'center !important',
                                  width: '100%',
                                }}
                              >
                                <h2
                                  className="font-black-16-bold my-2 card-title"
                                  style={{
                                    textAlign: 'center !important',
                                    alignItems: 'center !important',
                                    float: 'center !important',
                                  }}
                                >
                                  {item.EventName}
                                </h2>
                                {/* <p className="font-grey-12-normal my-2 card-text ">
                                  {item?.program?.title}
                                </p> */}
                                {/* <div className="d-flex flex-nowrap gap-1 align-items-center my-3">
                                  <i className="font-grey-12-normal my-0 py-0">
                                    Apply Before
                                  </i>
                                  <h6 className="font-black-12-bolder my-0 py-0 card-text">
                                    {moment(item.EventLastDate).format(
                                      'DD MMM, YYYY'
                                    )}
                                  </h6>
                                </div> */}
                                <div
                                  // className="d-flex flex-wrap my-0 py-0"
                                  style={{
                                    alignItems: 'center',
                                    flaot: 'center',
                                  }}
                                >
                                  <button
                                    className="primary-contained-button rounded-2 px-4 py-2"
                                    onClick={() => {
                                      const goToApplicationForm = (item) => {
                                        setLoading(true);
                                        getApplicationsByApplicantId(
                                          user?.applicantId
                                        ).then((res) => {
                                          const { data } = res;
                                          console.log(res);
                                          const sameApplicationFlag =
                                            data?.some(
                                              (el) =>
                                                el.Startup_Application_Form__c ===
                                                item.formId
                                            );
                                          const index = data?.findIndex(
                                            (el) =>
                                              el.Startup_Application_Form__c ===
                                              item.formId
                                          );
                                          setSameApplicationData(data[index]);
                                          if (sameApplicationFlag === true) {
                                            setLoading(false);
                                            setDialog(true);
                                          } else {
                                            setLoading(false);
                                            formDispatch({
                                              type: 'new',
                                              payload: {
                                                programDetails: {
                                                  ...item,
                                                  formId: item.formId,
                                                },
                                              },
                                            });
                                            navigate({
                                              pathname: '/application',
                                              search: `?formId=${item?.formId}`,
                                            });
                                          }
                                        });
                                      };
                                      goToApplicationForm(item);
                                    }}
                                  >
                                    Apply Now
                                  </button>
                                  {/* <button
                                    className="primary-text-button font-primary-14-bold mx-1"
                                    onClick={() =>
                                      navigate('/events', {
                                        state: {
                                          ...item,
                                        },
                                      })
                                    }
                                  >
                                    View More &nbsp;››
                                  </button> */}
                                </div>
                              </div>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </Box>
                </Grid>
                <Grid item md={12} height={'100%'}>
                  <Box
                    component={'div'}
                    width={'100%'}
                    className="bg-white rounded-2 shadow-sm h-100"
                    padding={'17px 20px'}
                  >
                    <h2 className="font-black-16-bold mb-2">
                      Frequently Asked Questions
                    </h2>
                    <div className="scroller-section mt-4 mb-2">
                      {QuestionContent.map((item, index) => (
                        <Box
                          component={'div'}
                          sx={{ marginRight: '8px' }}
                          border={
                            toggleValue === index ? '2px solid #07588F' : ''
                          }
                          borderRadius={toggleValue === index ? '4px' : ''}
                          onClick={() => setOpen(true)}
                        >
                          <Accordion
                            disableGutters
                            sx={{ boxShadow: '0' }}
                            key={index}
                            expanded={toggleValue === index && Open}
                            onChange={(event, expanded) => {
                              setToggleValue(index);
                            }}
                          >
                            <AccordionSummary
                              expandIcon={
                                toggleValue === index && Open ? (
                                  <BiMinus
                                    color={
                                      toggleValue === index
                                        ? '#07588F'
                                        : '#000000'
                                    }
                                    onClick={() => setOpen(false)}
                                  />
                                ) : (
                                  <GrFormAdd
                                    color={
                                      toggleValue === index
                                        ? '#07588F'
                                        : '#000000'
                                    }
                                    onClick={() => setOpen(true)}
                                  />
                                )
                              }
                              sx={{
                                '&.Mui-expanded': {
                                  color: '#07588F',
                                  // backgroundColor: '#F7F7F8',
                                },
                              }}
                            >
                              <h2
                                className={
                                  toggleValue === index
                                    ? classes.typoToggleOpenHeading
                                    : 'font-black-14-bold'
                                }
                              >
                                {item.Question}
                              </h2>
                            </AccordionSummary>
                            <AccordionDetails
                            // sx={{
                            //   backgroundColor:
                            //     toggleValue === index ? '#F7F7F8' : '',
                            // }}
                            >
                              <p className="font-grey-14-normal">
                                {item.Answer}
                              </p>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
      <KenDialog
        open={dialog}
        handleClose={() => {
          setDialog(false);
        }}
        dialogActions={true}
        positiveButtonProps={{
          style: {
            color: '#fff',
            backgroundColor: '#092682',
            borderRadius: '32px',
            '&:hover': {
              cursor: 'pointer',
              background: '#DFE8FF',
              color: '#505F79',
            },
            padding: '13px 52px',
            fontSize: 14,
            marginBottom: 16,
          },
        }}
        positiveButtonText={'Go To Your Application'}
        positiveButtonLabelProps={{
          style: {
            color: '#fff',
          },
        }}
        handleClickOpen={() => {
          setDialog(false);
        }}
        onClose={() => {
          setDialog(false);
        }}
        hideNegativeButton={true}
        positiveButtonClick={() => {
          sameApplicationData && goToSameApplication();
        }}
      >
        <Grid container p={2}>
          <Grid item>
            <Typography variant="body2">
              You have already applied for this application.
            </Typography>
          </Grid>
        </Grid>
      </KenDialog>
    </div>
  );
};

export default Dashboard;
